import Main from './SettingsMain'

const Settings = {
  Main,
}

export default Settings
